<template>
  <iColumn width="fill" gap="none">
    <SmartFeed
      v-if="collectionId"
      :source="useCollectionItemFeedStore"
      :default-feed-layout="getOptionValue(SmartFeedLayout)"
      :default-entity-size="getOptionValue(SmartFeedCardLayout)"
      :edit-mode="editMode"
    >
      <template #item="{feedItem}">
        <StudioFeedRowItem
          v-if="rowTemplateFor(feedItem.type).componentId > 0"
          :entity-id="feedItem.id"
          :dynamic-component-id="rowTemplateFor(feedItem.type).componentId"
          :context-name="rowTemplateFor(feedItem.type).contextName"
          :theme-mode="themeMode"
          :edit-mode="editMode"
        />
      </template>
      <template #empty-state>
        <iText variant="subtle">
          {{ getOptionValue(EmptyStateText) }}
        </iText>
      </template>
    </SmartFeed>
    <iText v-else-if="editMode" variant="subtle" data-test="collection-items-editor-hint">
      The products of the collection this page is opened for appear here.
    </iText>
  </iColumn>
</template>

<script>
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import StudioFeedRowItem from "%/dynamic-component-editor/standard-elements/StudioFeedRowItem.vue";
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import { collectionRowTemplate } from "%/dynamic-component-editor/helpers/collection-row-templates";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { SmartFeedElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import { useCollectionItemFeedStore } from "SmartFeed/stores/feed/collection-item-feed-store";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";
import { resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";

const PAGE_CONTEXT_NAME = "collectionItems";

export default {
  name: "CollectionItems",
  components: {
    SmartFeed,
    StudioFeedRowItem,
  },
  mixins: [
    DynamicElementMixin,
    SmartFeedElementMixin,
  ],
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
  },
  elementPanelSettings: {
    displayName: "Collection Items",
    displayIcon: "feed",
    elementGroup: "collectionItemsElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "No collection items yet." }),
  ],
  computed: {
    // The collection named by the page's url. Unset in the builder, where there is no url collection to
    // read: fetching collection 0 there was refused and left the canvas with a console error.
    collectionId() {
      return Number(resolveBoundEntityId(this, PAGE_CONTEXT_NAME)) || 0;
    },
    destinationId() {
      return useFanPublicationStore().publicationId || Number(window?.blclient?.data?.themeDestinationId ?? 0) || 0;
    },
  },
  created() {
    if (this.collectionId) {
      useCollectionItemFeedStore().collectionId = this.collectionId;
    }
  },
  methods: {
    useCollectionItemFeedStore,
    rowTemplateFor(entityType) {
      return collectionRowTemplate(entityType, this.getOptionValue(this.SmartFeedCardLayout), this.destinationId);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
